import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { Award, AwardColourPipe, AwardRankPipe } from '@rma/public/awards/public/api-awards';

@Component({
  selector: 'rma-market-report-award',
  templateUrl: './market-report-award.component.html',
  styleUrls: ['./market-report-award.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RmaIconComponent, AwardColourPipe, AwardRankPipe],
})
export class MarketReportAwardComponent {
  @Input() award: Award;
}
